var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"memberCenterPage"},[_c('iframe',{staticClass:"website",attrs:{"src":_vm.url,"frameborder":"0","marginheight":"0","name":"parentPage"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }